import React from "react";
import { Field, FastField } from "formik";
import get from "lodash.get";
import RadioButton from "../../../../../ui/widgets/radiobutton";
import { FieldProps } from "formik/dist/Field";
import { RadioButtonProps } from "../../../../../ui/widgets/radiobutton/types.tsx";

type OnboardingRadioButtonProps<T> = RadioButtonProps<T> & {
  forceReRender?: boolean;
  onChangeCallback?: (event: React.SyntheticEvent, value: T) => void;
};

const RadioButtonWrapper = <T,>({
  field,
  values,
  id,
  ...props
}: FieldProps & OnboardingRadioButtonProps<T>) => {
  function onChange(event: React.SyntheticEvent, newValue: number) {
    field.onChange({
      target: {
        value: values[newValue].value,
        name: id,
      },
    });
    if (props.onChangeCallback) {
      props.onChangeCallback(event, values[newValue].value);
    }
  }

  function onBlur(_: React.FocusEvent<HTMLDivElement>) {
    field.onBlur({
      target: {
        name: id,
      },
    });
  }
  const error = get(props, `form.errors.${field.name}`) as string;
  const touched = get(props, `form.touched.${field.name}`) as boolean;

  return (
    <RadioButton
      {...props}
      selectedValue={field.value}
      id={id}
      name={id}
      error={!!error && touched}
      errorText={error}
      onChange={onChange}
      onBlur={onBlur}
      values={values}
    />
  );
};

export default function OnboardingRadioButton<T>(
  props: OnboardingRadioButtonProps<T>,
): React.JSX.Element {
  return props.forceReRender ? (
    <Field component={RadioButtonWrapper} {...props} />
  ) : (
    <FastField component={RadioButtonWrapper} {...props} />
  );
}
